// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Tmfo6","marquee":"styles_marquee__UOlJD","marqueeContent":"styles_marqueeContent__38jUS","mar":"styles_mar__7qsu4"};